import * as React from 'react';
import { cn } from '../utils/tailwind-merge';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        'flex h-10 min-h-10 w-full rounded-full border border-neutral-alpha-7 bg-neutral-alpha-3 px-4 py-2 text-sm leading-[1.5] placeholder:text-neutral-11 disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
